// extracted by mini-css-extract-plugin
var _1 = "NewsboardList-moduleNewsboardList__v4AYr";
export { _1 as "NewsboardList" }
